// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap","title":"title","inputs":"inputs","footLinks":"footLinks","error":"error","reason":"reason"};


//////////////////
// WEBPACK FOOTER
// ./src/components/authpage.css
// module id = 183
// module chunks = 0